import React from 'react';
import Chip from '@mui/material/Chip';

const chipContainer = {
  backgroundColor: '#FAFDFF',
  borderColor: '#036FCB',
  fontWeight: 500,
};

const ReusableChip = ({
  selectedFields,
  chipType,
  handleDeleteSelectedFields,
}) => {
  return (
    <Chip
      data-testid="reusablechip-1"
      sx={chipContainer}
      variant="outlined"
      size="medium"
      label={`${chipType}: ${selectedFields}`}
      onDelete={handleDeleteSelectedFields}
    />
  );
};
export default ReusableChip;
